export default __webpack_public_path__ + "static/media/fruit@2x.f2842556.png";